export type AttachmentUploadStatus = "done" | "error" | "uploading" | "added";

/**
 * Pure. The one-line caption under an in-flight tile. Percent is the uploader's own
 * scale: parts are 0–90 %, and anything past that is the server finalizing or
 * processing the object, which no byte counter can express.
 */
export function describeUploadStage(
  status: AttachmentUploadStatus | undefined,
  percent: number,
): string | null {
  if (status === "error") return "Upload failed";
  if (status === "added") return "Waiting…";
  if (status !== "uploading") return null;
  if (percent >= 95) return "Processing…";
  return `Uploading ${Math.max(0, Math.min(99, Math.round(percent)))}%`;
}
